import * as actionTypes from '../actions/actionTypes';

const initialState = {
    tariff_plan: 8
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.SET_CURRENT_TARIFF:
            return {
                ...state,
                tariff_plan: action.payload
            };
        
        case actionTypes.GET_CURRENT_TARIFF:
            return {
                ...state
            };
        default:
            return state;
    }
};

export default reducer;